/****************************************************
 * Module Name:  mixBucketModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { Button } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "./../../style/modalstyle.css";
import MixBucketMaster from "../mixDiamondSales/mixBucketMaster";

const MixBucketModal = ({
  handleClose,
  show,
  apiType,
  barSourceData,
  aboveData,
  belowData,
}) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={Constants.COMPANY_LOGO}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp; Bucket Master
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MixBucketMaster
            apiType={apiType}
            editButton={true}
            barSourceData={barSourceData}
            aboveData={aboveData}
            belowData={belowData}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MixBucketModal;
